<template>
<div class="grid"  @click="edit">
<div class="col-3 md:col-2">
<p class="click_edit_value_title">{{title}}:</p>
</div>


<template v-if="editing">
<div class="col-9 md:col-10 mt-3">
<div class="grid"  v-click-away="notchanged">
<div class="col">




<Calendar v-model="inputdata" @date-select="submitChanges"   :showButtonBar="true" class="w-full p-inputtext-sm" :showOnFocus="true" :touchUI="true"  :inline="false" @today-click="submitChanges" @clear-click="submitChanges" autocomplete="off" />

</div>


<div class="col-fixed " style="width:110px">
<Button type="button"  icon="pi pi-check" @click="submitChanges" class="p-button-primary p-button-outlined p-button-sm mr-2"  :loading="$store.state.ui.submitting" />
<Button type="button"  icon="pi pi-times" @click="cancel" class="p-button-danger p-button-outlined p-button-sm "  :loading="$store.state.ui.submitting" />
</div>

</div>
</div>
</template>

<template v-if="!editing">	
<div class="col-9 md:col-10">
<p class="click_edit_value">
{{ $filters.momentFormat( value," Do-MM-YYYY")}}
</p>
</div>
</template>

</div>	
</template>

<script>
import moment from "moment" 
export default {

  name: 'ClickEditCalendar',
  props:["title","value","valkey"],
  data () {
    return {
    	editing:false,
    	inputdata:null,
    }
  },
  computed:{

  },
  watch:{
  	value(nevVal,oldVal)
  	{
  		
  		 this.editing = false
  	}
  },
  methods:{
  	submitChanges()
  	{
      console.log(this.inputdata);
      console.log(this.value);
  		if(this.inputdata !==this.value)
  		{
  			this.$emit("dataChanged",{value:moment(this.inputdata).format(),key:this.valkey})
  			//this.cancel()
  		}
  		else
  		{
  			this.cancel()
  		}
  		
  	},
  	edit()
  	{
  		this.editing = true
  		this.inputdata = this.value
  		
  		setTimeout(()=>{
  			if(this.$refs.inputarea)
  			{
  				this.$refs.inputarea.$el.focus()
  			}
  			
  		},10)
  		
  	},
  	cancel()
  	{
  		setTimeout(()=>{
  			this.editing = false
  		},10)
  		
  	},
    notchanged()
    {
      console.log(this.inputdata)
      console.log(this.value)
      if(this.inputdata ==this.value)
      {
        
        //this.cancel()
      }
    }

  }
};
</script>

<style lang="css" scoped>
</style>